/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface UploadFileWithDocumentTypeRequest
 */
export class UploadFileWithDocumentTypeRequest {
    /**
     *
     * @type {string}
     * @memberof UploadFileWithDocumentTypeRequest
     */
    accountId?: string;
    /**
     *
     * @type {string}
     * @memberof UploadFileWithDocumentTypeRequest
     */
    fileName?: string;
    /**
     *
     * @type {string}
     * @memberof UploadFileWithDocumentTypeRequest
     */
    fileContent?: string;
    /**
     *
     * @type {string}
     * @memberof UploadFileWithDocumentTypeRequest
     */
    documentType?: UploadFileWithDocumentTypeRequestDocumentTypeEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum UploadFileWithDocumentTypeRequestDocumentTypeEnum {
    NationalIdCard = 'NationalIDCard',
    Passport = 'Passport',
    DrivingLicense = 'DrivingLicense',
    UtilityBill = 'UtilityBill',
    BeneficiaryDeclaration = 'BeneficiaryDeclaration',
}
